import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button } from './css';
import ViewOrder from '../viewOrderSOW';


const View = ({ orderData, onSave, fetchData }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { viewOrder }
  } = localizedStrings;
  const [isViewOrderVisible, setIsViewOrderVisible] = useState(false);

  useEffect(() => {
    if (typeof isViewOrderVisible === 'undefined') {
      fetchData();
    }
  }, [isViewOrderVisible]);

  const showPopUp = () => {
    setIsViewOrderVisible(true);
  };

  const hidePopUp = () => {
    setIsViewOrderVisible(false);
  };

  const onStatusUpdateSuccess = () => {
    window.location.reload();
    hidePopUp();
  };

  return (
    <>
      <Button onClick={() => showPopUp()}>{viewOrder}</Button>
      {isViewOrderVisible && (
        <ViewOrder
        orderData={orderData}
        open={isViewOrderVisible}
        setOpen={setIsViewOrderVisible}
        onStatusUpdateSuccess={onStatusUpdateSuccess}
        onSave={onSave}
        fetchData={fetchData}
      />
      )}
    </>
  );
};

View.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  orderData: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchData: PropTypes.func.isRequired
};

export default View;
